import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Button,
  Card,
  Form,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Alert as BAlert,
  Spinner
} from 'react-bootstrap';
import {
  WidgetsOutlined,
  ArrowBackIos,
  ErrorOutlineOutlined,
  HelpOutline,
} from '@material-ui/icons';
import FundsRequestService from "services/funds-request";


export default function({
  companyId, fundTypeId, fiscalYear, title, action, editable
}){
  const [ fund, setFund ] = useState(0);
  const [ load, setLoad ] = useState(true);
  const value = (()=>{
    if(action){
      return action.action_values[0].value
    }
    return 0;
  })() 

  useEffect(()=>{
    setLoad(true)
    if(fundTypeId && fiscalYear){
      if(fundTypeId===3){
        FundsRequestService.getInfoScancash(fiscalYear, companyId).then(({data})=>{
          setFund(data.total_funds - data.total_actions)
          setLoad(false)
        })
      } else if(fundTypeId===4){
        FundsRequestService.getInfoInnovation(fiscalYear, companyId).then(({data})=>{
          setFund(data.total_funds - data.total_actions)
          setLoad(false)
        })
      } else if (fundTypeId===5) {
        FundsRequestService.getInfoElitePass(fiscalYear, companyId).then(({data})=>{
          setFund(data.total_funds - data.total_actions)
          setLoad(false)
        })
      } else if (fundTypeId===6) {
        FundsRequestService.getInfoScansourceSelect(fiscalYear, companyId).then(({data})=>{
          setFund(data.total_funds - data.total_actions)
          setLoad(false)
        })
      }
    }
  },[companyId, fundTypeId, fiscalYear])

  return (
    <Col sm="12" className="p-2 ">
      <Card.Body className="card-dashboard shadow bg-white rounded text-left row w-100 m-0">
        <div id="fund-table" className="col-md-12">
          <Row className="mb-4">
            <WidgetsOutlined className="icon-title" />
            <h5 className="title-dashboard">Fundos{title?` - ${title}`:""}</h5>
          </Row>
          <div className="card mb-4">
            <div className="card-body">
              <div className="fund-value">
                <h3 className="card-title mt-0" id="fund-free-fund">
                  {!load?(fund+(editable?value:0)).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }):<div>
                    <Spinner animation="border" size="sm" />
                    </div>}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Col>
  );
}